module.exports = __webpack_public_path__ + "img/score-moon.1deadd97.svg";